import { Component } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
  selector: 'cloud-business-hardware-certificates',
  templateUrl: './business-hardware-certificates.component.html',
  styleUrls: ['./business-hardware-certificates.component.scss']
})
export class BusinessHardwareCertificatesComponent {
  loaded = false;
  hasSecondTabBeenSelected = false;
  hasThirdTabBeenSelected = false;
  onTabChange(e: MatTabChangeEvent) {
    if (e?.index === 1) {
      this.hasSecondTabBeenSelected = true;
    } else if (e?.index === 2) {
      this.hasThirdTabBeenSelected = true;
    }
  }
}
